import {
  PayPeriod,
  PayPeriodResponse,
  WeekSummary,
  DriverPayPeriodSummary,
  PayPeriodSummaryResponse
} from '../../../models/PayPeriod';

export const getPayPeriod = (data: any): PayPeriod => {
  return {
    id: data.id,
    startDate: data.start_date,
    endDate: data.end_date,
    previousId: data.previous_id || undefined,
    nextId: data.next_id || undefined,
  };
};

export const getPayPeriodResponse = (data: any): PayPeriodResponse => {
  return {
    payPeriod: getPayPeriod(data.pay_period),
    hasPrevious: !!data.has_previous,
    hasNext: !!data.has_next,
  };
};

export const getWeekSummary = (data: any): WeekSummary => {
  return {
    week: data.week,
    startDate: data.start_date,
    endDate: data.end_date,
    totalMinutes: data.total_minutes,
    regularMinutes: data.regular_minutes,
    overtimeMinutes: data.overtime_minutes,
  };
};

export const getDriverPayPeriodSummary = (data: any): DriverPayPeriodSummary => {
  return {
    driverId: data.driver_id,
    driverName: data.driver_name,
    weeks: data.weeks?.map(getWeekSummary) || [],
    totalMinutes: data.total_minutes,
    totalRegularMinutes: data.total_regular_minutes,
    totalOvertimeMinutes: data.total_overtime_minutes,
  };
};

export const getPayPeriodSummaryResponse = (data: any): PayPeriodSummaryResponse => {
  return {
    payPeriod: getPayPeriod(data.pay_period),
    summaries: data.summaries?.map(getDriverPayPeriodSummary) || [],
  };
};
